// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"46b19ff4","247":"45d41fe2","268":"de903ad3","484":"fd13a02c","627":"a71f3f13","768":"b1f984e5","828":"7fcf9443","834":"73fc65ed","867":"b2145e5f","923":"fbb3b7f8","938":"7e6d706b"}[chunkId] + ".chunk.js";
};